module.exports = __webpack_public_path__ + "143c8ee9952bc862af74e12626ccddbc.svg";